import _ from 'lodash';
import { elementTypes } from 'crazyEditor/components/Elements/index';

/*
 Remove element props from element structure.
 */
export function addIsTextElementIndication(element) {
  if (element.type === elementTypes.TitleElement || element.type === elementTypes.RichTextElement || element.type === elementTypes.TabsElement) {
    _.assign(element, {isTextElement: true});
  }
}
